const ShareIcon = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
        <path
            d="M4.09375 12.2188V17.9688C4.09375 18.35 4.2452 18.7156 4.51478 18.9852C4.78437 19.2548 5.15 19.4062 5.53125 19.4062H18.4688C18.85 19.4062 19.2156 19.2548 19.4852 18.9852C19.7548 18.7156 19.9062 18.35 19.9062 17.9688V12.2188M12 14.375V2.51562M16.3125 6.46875L12 2.15625L7.6875 6.46875"
            stroke="#E0BE74" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
}

export default ShareIcon